/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type TopicsList_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopicsApp_viewer$ref: FragmentReference;
export type TopicsApp_viewer = {|
  +$fragmentRefs: TopicsList_viewer$ref,
  +$refType: TopicsApp_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "TopicsApp_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "section",
      "type": "ID!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TopicsList_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '343ea5d6f3769ab9d47b28203659814b';
module.exports = node;



// WEBPACK FOOTER //
// src/components/topics/__generated__/TopicsApp_viewer.graphql.js